import { render, staticRenderFns } from "./StockBalancesTab.vue?vue&type=template&id=85e145f4&"
import script from "./StockBalancesTab.vue?vue&type=script&lang=ts&"
export * from "./StockBalancesTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports